import { z } from 'zod/v4';

import { RemoveByValue } from '../http/types/removeByValue';
import { webSocketEndpointRegistry } from './websocketEndpointRegistry';

export type WebSocketEndpointRegistry = typeof webSocketEndpointRegistry;
export type RegisteredWebSocketEndpoint = keyof typeof webSocketEndpointRegistry;

export type WebSocketFullEndpointOptions<T extends RegisteredWebSocketEndpoint> = {
    pathParams: z.infer<WebSocketEndpointRegistry[T]['pathParams']>;
    queryParams: z.infer<WebSocketEndpointRegistry[T]['queryParams']>;
};

export type WebSocketEndpointOptions<T extends RegisteredWebSocketEndpoint> = RemoveByValue<
    WebSocketFullEndpointOptions<T>,
    undefined
>;

export type WebSocketMessageHandler<T extends RegisteredWebSocketEndpoint> = (
    message: z.infer<WebSocketEndpointRegistry[T]['responseMessage']>,
) => void;
